<template>
  <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <div v-if="type == 'error'">
              <i class="icon ico-info"></i>
            </div>
            <div v-else>
              <i class="icon ico-check"></i>
            </div>


            <h3>No hemos podido crear tu oferta</h3>
          </div>

          <div class="modal-body">
            <slot name="body">
              Por favor, inténtalo más tarde.
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-primary btn-modal" @click="hideModal">
                Aceptar
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'modal',
  props: ['type'],
  methods: {
    hideModal: function(){
      this.$emit('closeModal');
    }
  }
}
</script>

<style>
.modal-mask {
  font-family: Roboto;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  text-align:center;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  font-size: 20px;
}

.modal-header i{
  color: #f8b91c;
  font-size: 72px;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-footer{
  text-align: center;
}

.btn-modal{
  padding: 15px 20px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


